import React, { useMemo } from 'react'
import { makeStyles } from '@mui/styles'
import ThemeInterface from '@/theme-interface'

import lang from '@/lang'
import { SignatureItem } from '@/modules/signature/types'
import SignatureSigningItem from '@/modules/signature/components/signing/signature-signings/signature-signing-item/signature-signing-item'
import { useSignatureContext } from '@/modules/signature/_helpers/SignatureContext'
import { useAppSelector } from '@/redux/store'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontSize: theme.fontSizes.smedium,
    fontWeight: theme.fontWeights.medium,
    marginBottom: 20,
  },
  items: {
    display: 'flex',
    flexDirection: 'column',
  },
  hint: {
    fontSize: theme.fontSizes.smaller,
    marginTop: 20,
  },
}), { name: 'SignatureSignings' })

type SignatureSigningsProps = {
  isUserCreator: boolean,
  readOnly: boolean,
  signatureItems: SignatureItem[],
  doneSignatureItems: SignatureItem[],
}

const SignatureSignings = (props: SignatureSigningsProps) => {
  const classes = useStyles()
  const { isUserCreator, readOnly, signatureItems, doneSignatureItems } = props
  const { currentItemIndex } = useSignatureContext()
  const userEmail = useAppSelector(state => state.user.info.email)
  const isTaxConsultant = useAppSelector(state => state.tenant.info.isTaxConsultant)

  const signatureItemEls = useMemo(() => {
    return signatureItems.map((signatureItem, index) => {
      const { signerEmail, signed } = signatureItem
      const isReadOnly = readOnly || (userEmail !== signerEmail && !isTaxConsultant) || signed
      return (
        <SignatureSigningItem
          key={index}
          index={index}
          signatureItem={signatureItem}
          readOnly={isReadOnly}
          isUserCreator={isUserCreator}
          active={index === currentItemIndex} />
      )
    })
  }, [isUserCreator, readOnly, signatureItems, currentItemIndex, userEmail, isTaxConsultant])

  return (
    <div className={classes.root}>
      <div className={classes.title}>
        {lang.signature.signing.signatures.title(doneSignatureItems.length, signatureItems.length)}
      </div>
      <div className={classes.items}>
        {signatureItemEls}
      </div>
      <div className={classes.hint}>
        {!readOnly && lang.signature.signing.signatures.hint}
      </div>
    </div>
  )
}

export default SignatureSignings
